enum EventPhaseEnum {
	none = 0,
	capturing = 1,
	atTarget = 2,
	bubbling = 3
}
export default EventPhaseEnum;
